<div class="consultant-card-container">
  <div
    class="row consultantCard"
    [class.clickable-card]="consultant?.HasProfile"
    (click)="openPreview($event)"
  >
    <div class="consultant-card-subsection consultant-card-edit-subsection">
      <mat-icon
        *ngIf="isEditEnabled"
        (click)="editConsultantSkills($event)"
        (mousedown)="$event.stopPropagation()"
        class="clickable"
      >
        edit
      </mat-icon>

      <mat-icon
        *ngIf="consultant?.Email"
        class="clickable"
        (click)="sendEmail($event)"
        (mousedown)="$event.stopPropagation()"
      >
        mail_outline
      </mat-icon>

      <mat-icon
        *ngIf="!isExpandEnabled"
        (click)="showConsultantInformation($event)"
        (mousedown)="$event.stopPropagation()"
        class="clickable"
      >
        info_outline
      </mat-icon>

      <app-profile-completeness-indicator
        *ngIf="consultant"
        [displayProfileSections]="consultant.CompletedProfileSections"
        displayStyle="round-all"
      ></app-profile-completeness-indicator>
    </div>

    <div
      class="consultant-card-subsection consultant-card-profile-image-subsection"
    >
      <app-profile-photo
        *ngIf="consultant"
        [key]="consultant.AzureId"
      ></app-profile-photo>
    </div>

    <div
      class="consultant-card-subsection consultant-card-person-details-subsection"
    >
      <div
        class="consultant-card-link-area"
        [class.clickable-name]="consultant?.HasProfile"
      >
        <div class="consultant-card-display-name">
          {{ $safeNavigationMigration(consultant?.DisplayName) | nameDisplay }}
        </div>

        <app-profile-primary-capability-badge
          *ngIf="consultant?.PrimaryCapabilityName || consultant?.Capability"
          [capabilityName]="
            consultant?.PrimaryCapabilityName || consultant?.Capability
          "
        ></app-profile-primary-capability-badge>

        <div class="consultant-card-title-line" *ngIf="consultant?.Role">
          {{ consultant.Role }}
        </div>
      </div>

      <div class="consultant-card-meta-line" *ngIf="consultant?.Organisation">
        {{ consultant.Organisation }}
      </div>

      <div class="consultant-card-meta-line" *ngIf="consultant?.Location">
        {{ consultant.Location }}
      </div>
    </div>

    <div
      class="consultant-card-subsection consultant-card-skills-subsection"
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
    >
      <div *ngIf="maxCollapsedSkillsToDisplay > 0">
        <div class="skills-trim-wrap trim-to-single-line">
          <app-skill-chip-list
            [skills]="skillsToDisplay"
            [selectedSkillIds]="matchedSkillIds"
            (chipClick)="onSkillChipClicked($event)"
          ></app-skill-chip-list>
        </div>
      </div>

      <div class="expand-collapse-button-container" *ngIf="isExpandEnabled">
        <button
          mat-icon-button
          type="button"
          class="expand-toggle"
          data-testid="open-profile-preview"
          (click)="openPreview($event)"
          (mousedown)="$event.stopPropagation()"
          [disabled]="!consultant?.HasProfile"
          [attr.aria-label]="
            consultant?.HasProfile
              ? 'Open profile preview'
              : 'Profile preview unavailable'
          "
        >
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <app-team-toggle-button
    *ngIf="enableTeamToggle"
    [consultant]="consultant"
  ></app-team-toggle-button>
</div>
